import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { QueryKey } from "@tanstack/react-query";
import Sheet from "components/shared/Sheet";
import EditForm from "../components/EditForm";
import { useVisible } from "utils/hooks/useVisible";
import { useUser } from "utils/hooks/user";
import { isCreatedBy } from "./useColumns";

interface UseEditSheetProps {
    queryOptions: { queryKey: QueryKey };
}

export const useEditSheet = ({ queryOptions }: UseEditSheetProps) => {
    const { t } = useTranslation();
    const { open, close, visible, selected } = useVisible();
    const user = useUser();
    const extraPayOnly = (selected as any)?.type === "direct-offer" || !isCreatedBy(selected, user);
    const hasExtraPay = (selected as any)?.data?.extraPayment?.payAmount != null
        && (selected as any)?.data?.extraPayment?.payAmount !== "";
    const title = extraPayOnly
        ? t(hasExtraPay ? "edit-extra-pay" : "add-extra-pay")
        : t("edit-request");

    const sheet = useMemo(() => {
        return (
            <Sheet
                title={title}
                open={visible}
                close={close}
                bodyClassName="tw-flex tw-flex-col tw-overflow-hidden"
            >
                {selected && (
                    <EditForm
                        key={(selected as any)?.id}
                        request={selected}
                        close={close}
                        extraPayOnly={extraPayOnly}
                        queryOptions={queryOptions}
                    />
                )}
            </Sheet>
        );
    }, [close, queryOptions, selected, visible, title, extraPayOnly]);

    return { open, sheet };
};
